import {AbstractParameter, IntegerParameter} from 'parameters/AbstractParameter.js';
import Tone from 'tone';
import {AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {loadParameterFromJson, saveParameterToJson} from 'parameters/parameterJsonFunctions.js';
import AbstractOscillator from './synth/oscillator/AbstractOscillator.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';
import {mate} from 'genetix/Flip.js';

class FMCarrierOscillator extends AbstractOscillator {
    constructor(sequencerEngine, mixSession, context) {
        super(sequencerEngine,
              mixSession,
              context,
              (polyphony) => new Tone.PolySynth(polyphony, Tone.FMSynth));
    }

    setupParameters() {
        super.setupParameters();

        // harmonicity
        this.harmonicityParameter = new AbstractAudioParamParameter(
            'Harmonicity', this,
            (o, harmonicity) => o.synth.set({
                "harmonicity": harmonicity
            }),
            {
                min: 0,
                max: 20,
                unit: '',
                defaultValue: 3,
            });

        this.registerParameter(this.harmonicityParameter);

        // modulationIndex
        this.modulationIndexParameter= new AbstractAudioParamParameter(
            'modulationIndex', this,
            (o, modulationIndex) => o.synth.set({
                "modulationIndex": modulationIndex
            }),
            {
                min: 0,
                max: 1000,
                unit: '',
                defaultValue: 10,
            });

        this.harmonicityParameter.setAudioParams(this.synth.voices.map(voice => voice.harmonicity));
        this.modulationIndexParameter.setAudioParams(this.synth.voices.map(voice => voice.modulationIndex));

        this.partialCountParameter = new AbstractParameter(
            'Partial Count', this,
            (o, x) => o.synth.set({
                "oscillator": {
                    "partialCount": x,
                },
            }),
            {
                min: 0,
                automatable: false,
                max: 16,
                unit: '',
                defaultValue: 0,
            });

        this.registerParameter(this.partialCountParameter);

        this.registerParameter(this.modulationIndexParameter);
    }

    get harmonicity() {
        return this.harmonicityParameter.get();
    }

    set harmonicity(s) {
        return this.harmonicityParameter.set(s);
    }

    get modulationIndex() {
        return this.modulationIndexParameter.get();
    }

    set modulationIndex(m) {
        return this.modulationIndexParameter.set(m);
    }


    get partialCount() {
        return this.partialCountParameter.get();
    }

    set partialCount(c) {
        return this.partialCountParameter.set(c);
    }

    refreshParameters() {
        super.refreshParameters();

        this.harmonicity = this.harmonicity;
        this.modulationIndex = this.modulationIndex;
        this.partialCount = this.partialCount;
        this.harmonicityParameter.setAudioParams(this.synth.voices.map(voice => voice.harmonicity));
        this.modulationIndexParameter.setAudioParams(this.synth.voices.map(voice => voice.modulationIndex));
    }

    getJson() {
        let json = {
            ... super.getJson(),
            harmonicity: this.harmonicity,
            modulationIndex: this.modulationIndex,
            partialCount: this.partialCount
        };

        json = saveParameterToJson(json, 'harmonicityParameter', this.harmonicityParameter);
        json = saveParameterToJson(json, 'modulationIndexParameter', this.modulationIndexParameter);
        json = saveParameterToJson(json, 'partialCountParameter', this.partialCountParameter);
        return json;
    }

    fromJson(json) {
        super.fromJson(json, undefined, true);
        console.log("osc =", json);

        this.harmonicity = parseFloat(json.harmonicity);
        this.modulationIndex = parseFloat(json.modulationIndex);
        this.partialCount  = json.partialCount;
            
        loadParameterFromJson(json, 'harmonicityParameter', this.harmonicityParameter, this.sequencerEngine);
        loadParameterFromJson(json, 'modulationIndexParameter', this.modulationIndexParameter, this.sequencerEngine);
        loadParameterFromJson(json, 'partialCountParameter', this.partialCountParameter, this.sequencerEngine);
    }

    mateJson(partner, probability) {
        super.mateJson(partner, probability);
        this.mateParameter('harmonicity', partner, this.harmonicityParameter, probability);
        this.mateParameter('modulationIndex', partner, this.modulationIndexParameter, probability);
        this.mateParameter('partialCount', partner, this.partialCountParameter, probability);
    }

}

export default FMCarrierOscillator;
